import { render, staticRenderFns } from "./JournalEntries.vue?vue&type=template&id=b54dc454&"
import script from "./JournalEntries.vue?vue&type=script&lang=js&"
export * from "./JournalEntries.vue?vue&type=script&lang=js&"
import style0 from "./JournalEntries.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports